import { GenericTabs } from '@AMIEWEB/Common/Tabs/GenericTabs';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import OrderPayPackageTab from './OrderPayPackages/OrderPayPackageTab';
import { PlacementPayPackagesWrapper } from './PlacementPayPackages/PlacementPayPackagesWrapper';
import { useDispatch } from 'react-redux';
import { orderDataActions } from '@AMIEWEB/Order/Store/Order.redux';
import { useParams } from 'react-router-dom';

export const PayPackagesWrapper = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id: orderId } = useParams();
  useEffect(() => {
    dispatch(orderDataActions.getOrderPayPackages({ orderId: Number(orderId) }));
  }, [orderId, dispatch]);
  const tabs = [
    {
      label: t('order.payPackagesTab.orderPayPackages.title'),
      component: <OrderPayPackageTab />,
    },
    {
      label: t('order.payPackagesTab.placementPayPackages.title'),
      component: <PlacementPayPackagesWrapper orderId={Number(orderId)} />,
    },
  ];
  return (
    <>
      {' '}
      <GenericTabs tabs={tabs} hideHorizontalBorder />
    </>
  );
};
